// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","loaderContainer":"circles-loader_loaderContainer__iSB9Q","loaderCircle":"circles-loader_loaderCircle__9pP6F","active":"circles-loader_active__Aj0F9"};